<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="h1" data-automation-id="dialog-title">{{ title }}</h2>
  <button
    mat-icon-button
    [mat-dialog-close]="false"
    aria-label="{{ message }} dialog"
    data-automation-id="dialog-close-button"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p data-automation-id="dialog-message">{{ message }}</p>
  <form *dynamicFormInfo="formInfo">
    <div class="row">
      <div class="col-6">
        <h5>Reviewer Type</h5>
        <p data-automation-id="assignee-modal_202127112136">{{ priorAuthRequestType }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <app-select-input
          #assigneeList
          controlName="assigneeSystemUserEntityGroupId"
          [fetchData]="assigneeOptions$"
        ></app-select-input>
      </div>
    </div>
    <div class="dialog-footer">
      <button
        type="submit"
        mat-flat-button
        color="primary"
        data-automation-id="modal-save-button"
        (click)="assignWorkRequest($event)"
        [disabled]="!assigneeForm?.valid"
        attr.aria-label="{{ message }}"
      >
        Assign
      </button>
      <button
        type="button"
        mat-stroked-button
        color="primary"
        [mat-dialog-close]="false"
        aria-label="Close {{ message }} dialog"
        data-automation-id="modal-cancel-button"
      >
        Cancel
      </button>
    </div>
  </form>
</mat-dialog-content>
